import Reveal from "@stimulus-components/reveal";

// Connects to data-controller="reveal-with-disable-inputs"
export default class extends Reveal {
  static targets = ["separateItem", "item"];
  connect() {
    super.connect();
    this.updateDisabled();
  }

  updateDisabled() {
    [...this.separateItemTargets, ...this.itemTargets].forEach((el) => {
      const shouldDisable = el.classList.contains(this.hiddenClass);
      el.querySelectorAll("input, select, textarea, button").forEach(
        (field) => (field.disabled = shouldDisable)
      );
    });
  }

  toggle() {
    super.toggle();
    this.updateDisabled();
  }

  onChange(event) {
    const val = (event?.target?.value ?? "").toString().toLowerCase();

    const showSeparate = val === "true" || val === "1" || val === "yes";

    this.#setVisible(this.separateItemTargets, showSeparate);
    this.#setVisible(this.itemTargets, !showSeparate);
    this.updateDisabled();
  }

  #setVisible(elements, visible) {
    elements.forEach((el) => {
      el.classList.toggle(this.hiddenClass, !visible);
    });
  }

  show() {
    super.show();
    this.updateDisabled();
  }

  hide() {
    super.hide();
    this.updateDisabled();
  }
}
